export const replaceAgreement = (src) => {
  const reg = /^(http|https):/i;
  return src.replace(reg, '');
};